const utilisation = {
  chart: {
    height: "550",
    zoomType: "xy"
  },
  tooltip: {
    backgroundColor: "rgba(0, 0, 0, 0.85)",
    borderColor: "rgba(0, 0, 0, 0.85)",
    style: {
      color: "#F0F0F0"
    }
  },
  xAxis: {
    gridLineWidth: 1,
    tickWidth: 1,
    tickInterval: 20,
    gridLineDashStyle: "LongDash",
    startOnTick: true,
    alignTicks: false,
    endOnTick: true,
    showLastLabel: true,
    labels: {
      style: {
        fontFamily: "Unica One, sans-serif",
        color: "#3C3C3C",
        fontWeight: "bold",
        fontSize: "12px"
      }
    },
    lineColor: "#D7D7D8",

    tickColor: "#D7D7D8",
    tickWidth: 1,
    title: {
      style: {
        fontWeight: "bold",
        color: "#000000",
        fontSize: "14px"
      },
      floating: true,
      y: 15
    }
  },
  yAxis: {
    labels: {
      style: {
        fontFamily: "Unica One, sans-serif",
        color: "#3C3C3C",
        fontWeight: "bold",
        fontSize: "12px"
      }
    },
    lineColor: "#707070",
    lineWidth: 1,
    gridLineWidth: 0,
    tickInterval: 20,
    tickWidth: 1,
    startOnTick: false,
    alignTicks: false,
    endOnTick: false,
    title: {
      floating: true,
      x: -15,
      style: {
        color: "#000000",
        fontWeight: "bold",
        fontSize: "14px"
      }
    },
    plotLines: [
      {
        color: "#707070",
        width: 1,
        value: 100
      }
    ]
  },
  plotOptions: {
    series: {
      states: {
        hover: {
          enabled: true,
          halo: {
            size: 1
          }
        }
      }
    }
  }
};

export default utilisation;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartScatterUtlisationConfig.js